/* eslint-disable react/no-array-index-key */
import React, { Component } from "react";
import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import "jspolyfill-array.prototype.find";
import QuickReply from "../QuickReply";
import Carousel from "../Carousel";
import GenericText from "../GenericText";
import dpzLogo from "../../images/dpz-logo.svg";
import Loader from "../Loader";
import "./css/chatHistory.css";

import ChatReceipt from "../ChatReceipt";

class ChatHistory extends Component {
  static isCarousel(mediaArray) {
    return mediaArray.length === 1
      ? false
      : mediaArray.reduce((isCarousel, media) => {
          if (isCarousel) return media.type === "CAROUSEL";
          return false;
        }, true);
  }

  static isReceipt(mediaArray) {
    return mediaArray.some(media => media.type === "RECEIPT");
  }

  static getChatType(chat) {
    if (
      chat.chatType &&
      (chat.chatType === "cart" || chat.chatType === "checkout")
    ) {
      return chat.chatType;
    } else if (chat.suggestions && chat.suggestions.length > 0) {
      return "quick-reply";
    } else if (chat.media) {
      return "attachment--button";
    }
    return "";
  }

  static fixMissingImage(evt) {
    const el = evt.target;
    el.setAttribute("src", dpzLogo);
    el.setAttribute("class", "missing-image");
  }

  constructor() {
    super();
    this.scrollChatToBottom = this.scrollChatToBottom.bind(this);
  }

  /* START CORE-12106 */
  componentDidMount() {
    if (this.props.isPizzaBuilder) {
      DOMPurify.addHook("afterSanitizeAttributes", node => {
        // set all elements owning target to target=_parent
        if ("target" in node) {
          node.setAttribute("target", "_parent");
        }
      });
    }
  }
  /* END CORE-12106 */

  componentDidUpdate() {
    this.scrollChatToBottom();
  }

  /* START CORE-12106 */
  componentWillUnmount() {
    if (this.props.isPizzaBuilder) {
      DOMPurify.removeHook("afterSanitizeAttributes");
    }
  }
  /* END CORE-12106 */

  scrollChatToBottom() {
    this.chatHistory.scrollTop = this.chatHistory.scrollHeight;
  }

  render() {
    return (
      <div
        data-quid="chat-history"
        className="chat__history"
        ref={element => {
          this.chatHistory = element;
        }}
      >
        <ul className="chat__history__list">
          {this.props.chats.map((chat, index) => (
            <li
              key={index}
              className={`chat__history__item ctHidden ${
                chat.author
              } ${ChatHistory.getChatType(chat)} ${
                chat.media && ChatHistory.isReceipt(chat.media)
                  ? "chat__history__item--receipt"
                  : ""
              } ${
                chat.media && ChatHistory.isCarousel(chat.media)
                  ? "chat__history__item--carousel"
                  : ""
              } `}
              data-quid={`chat-history-item-${index}`}
            >
              {chat.headerImage && (
                <img
                  data-quid="header-image"
                  className="header__image"
                  src={chat.headerImage.url}
                  alt="historical order"
                  onLoad={this.scrollChatToBottom}
                  onError={evt => ChatHistory.fixMissingImage(evt)}
                />
              )}

              {chat.media && ChatHistory.isReceipt(chat.media) ? (
                <p
                  data-quid="chat-history-item-message"
                  className="chat__history__item__message"
                >
                  Order Summary
                </p>
              ) : (
                <p
                  data-quid="chat-history-message"
                  className="chat__history__item__message"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(chat.message)
                  }}
                />
              )}

              {chat.media && ChatHistory.isReceipt(chat.media) && (
                <ChatReceipt
                  receipt={chat.media.find(media => media.type === "RECEIPT")}
                />
              )}

              {chat.media &&
                (ChatHistory.isCarousel(chat.media) ? (
                  <Carousel
                    reply={chat}
                    addButtonResponse={this.props.addButtonResponse}
                    scrollChatToBottom={this.scrollChatToBottom}
                    fixMissingImage={ChatHistory.fixMissingImage}
                  />
                ) : (
                  <GenericText
                    reply={chat}
                    addButtonResponse={this.props.addButtonResponse}
                    scrollChatToBottom={this.scrollChatToBottom}
                    fixMissingImage={ChatHistory.fixMissingImage}
                    logout={this.props.logout}
                    showOverlay={this.props.showOverlay}
                    sendCartToDomDotCom={this.props.sendCartToDomDotCom}
                    backToBuilder={this.props.backToBuilder}
                    initiateBuilderChat={
                      this.props.initiateBuilderChat
                    } /* END CORE-12106 */
                  />
                ))}

              {chat.suggestions && chat.suggestions.length > 0 && (
                <QuickReply
                  reply={chat}
                  addButtonResponse={this.props.addButtonResponse}
                />
              )}
              <div className="triangle" />
            </li>
          ))}
          {this.props.loading && <Loader />}
        </ul>
      </div>
    );
  }
}

ChatHistory.propTypes = {
  chats: PropTypes.arrayOf(PropTypes.object).isRequired,
  addButtonResponse: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  showOverlay: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  sendCartToDomDotCom: PropTypes.func.isRequired /* START CORE-12106 */,
  backToBuilder: PropTypes.func,
  initiateBuilderChat: PropTypes.func,
  isPizzaBuilder: PropTypes.bool /* END CORE-12106 */
};

/* START CORE-12106 */
ChatHistory.defaultProps = {
  backToBuilder: null,
  initiateBuilderChat: null,
  isPizzaBuilder: false
};
/* END CORE-12106 */

export default ChatHistory;
